import React, { useRef } from 'react';
import Modal from '@mui/material/Modal';
import sookiTopQR from '../../images/QR_852319.png';
import Utility from '../../Consts/Utility';
import { modalProps } from '../../Consts/constants';

interface PreviewProps {
    adminPassword: string;
    userPassword: string;
    siteId: string;
    gateways: [{
        contactEnd: string,
        controlId: string,
        gatewayId: string,
        gatewayRecno: number,
    }]
}
const PreviewAdmin = ({ adminPassword, userPassword, siteId, gateways }: PreviewProps) => {
    console.log(gateways);

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    // const printAreaRef = useRef<HTMLDivElement | null>(null);

    function printElement(id: string): void {
        console.log(id);
        const area = document.getElementById(id);
        const contentToPrint = document.getElementById('contentToPrint');
        const modalPrints = document.getElementsByClassName('MuiModal-root');
        const wrappers = document.getElementsByClassName('wrapper');

        if (area && contentToPrint) {
            contentToPrint.innerHTML = area.innerHTML;
            contentToPrint.style.display = 'block';
            for (var i = 0; i < modalPrints.length; i++) {
                var element = modalPrints[i] as HTMLElement;
                element.style.display = 'none';
            }
            for (var i = 0; i < wrappers.length; i++) {
                var element = wrappers[i] as HTMLElement;
                element.style.display = 'none';
            }
            window.print();
            contentToPrint.style.display = 'none';
            for (var i = 0; i < modalPrints.length; i++) {
                var element = modalPrints[i] as HTMLElement;
                element.style.display = 'block';
            }
            for (var i = 0; i < wrappers.length; i++) {
                var element = wrappers[i] as HTMLElement;
                element.style.display = 'block';
            }

        } else {
            console.error(`Element with ID '${id}' not found.`);
        }
    }
    // 現在の日付を取得
    const today = new Date();
    const formatedDate = Utility.formatDate(today);
    const ReformatDate = Utility.ReformatDate(formatedDate);

    return (
        <>
            <button onClick={handleOpen} className="btn btn-blue-line">
                <i className="icon-print-b"></i>印刷
            </button>
            <Modal {...modalProps} open={open}>
                <div className="modal-wrapper" id="modal-message">
                    <div className="modal modal-wide">
                        <div className="modal-header">
                            <div className="modal-title">
                                印刷プレビュー
                                <div className="page-info-box">
                                    <div className="page-info-item">
                                        <span className="page-info-label">現場ID</span>
                                        {siteId}
                                    </div>
                                </div>
                            </div>
                            <a onClick={handleClose} className="modal-close"></a>
                        </div>
                        <div className="modal-body">
                            <div className="print-box">
                                <div className="print-area" id="print-area">
                                    <div className="print-date">{ReformatDate}</div>
                                    <div className="print-no">
                                        <div className="print-no-label">
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td>管理番号: </td>
                                                        <td>
                                                            {gateways.length ? gateways.map((gateway, index) => (
                                                                <p key={index}>
                                                                    {gateway.controlId}
                                                                </p>
                                                            )) : <></> }
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="print-no-data">
                                            <br />
                                        </div>
                                    </div>
                                    <div className="print-title">ユーザー情報通知書</div>
                                    <div className="print-body">
                                        <table className="print-table">
                                            <tbody>
                                                <tr>
                                                    <td>ID</td>
                                                    <td>{siteId}</td>
                                                </tr>
                                                <tr>
                                                    <td>管理パスワード</td>
                                                    <td>{adminPassword}</td>
                                                </tr>
                                                <tr>
                                                    <td>閲覧パスワード</td>
                                                    <td>{userPassword}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div className="print-mid">ポータルへのアクセス</div>
                                        <p>下記URLもしくはQRコードでアクセスし、ID/パスワードを入力のうえログインしてご利用ください。</p>
                                        <div className="print-url">ポータルURL : https://www.sooki-cloud-portalsystem.jp/
                                        </div>
                                        <div className="print-qr">
                                            <div className="print-qr-label">ポータル用QRコード：:</div>
                                            <div className="print-qr-code">
                                                <img src={sookiTopQR} className="print-qr-qr" />
                                            </div>
                                        </div>
                                        <hr className="print-hr" />
                                        <div className="print-mid">LINEでのアクセス</div>
                                        <p>下記QRコードをLINEで読み取り、友だち追加のうえご利用ください。</p>
                                        <div className="print-url"></div>
                                        <div className="print-qr">
                                            <div className="print-qr-label">LINE用QRコード：</div>
                                            <div className="print-qr-code">
                                                <img src="https://qr-official.line.me/gs/M_497zrnpf_BW.png?oat_content=qr" className="print-qr-qr" />
                                            </div>
                                        </div>
                                        <hr className="print-hr" />
                                        <p>※注意事項<br />
                                            ・ID/パスワードは紛失しないよう大切に管理してください。<br />
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="model-action-sub">

                            </div>
                            <div className="model-action-main">
                                <button onClick={handleClose} className="btn btn-blue-line">
                                    キャンセル
                                </button>
                                <button className="btn btn-blue col-160" type="button"
                                    onClick={() => printElement('print-area')}>
                                    <i className="icon-print-w"></i>印刷実行
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};
export default PreviewAdmin;

